<div class="modalForm" [formGroup]="form">
  @if(loading()){
  <div class="flex h-full justify-content-center align-items-center" style="grid-column: 1/3">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
  } @else {
  <div class="flex flex-column gap-2 mb-3">
    <label for="version" class="font-semibold w-full"
      >{{ "device_management.software.form.version" | translate }}*</label
    >
    <input pInputText id="version" formControlName="version" autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="version" class="font-semibold w-full">
      {{ "device_management.software.form.device_type" | translate }} *</label
    >
    <p-select class="w-full" appendTo="body" [options]="deviceTypes()" formControlName="deviceType" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="file1" class="font-semibold w-full">
      {{ "device_management.software.form.file_1" | translate }} *
    </label>
    <p-fileUpload
      id="file1"
      [showUploadButton]="false"
      [showCancelButton]="false"
      styleClass="customFileUpload"
      [style]="{ 'flex-direction': 'row' }"
      class="w-full"
      [chooseLabel]="translate.instant('device_management.software.form.choose_file')"
      [customUpload]="true"
      [auto]="false"
      (onSelect)="onFileSelect('file1', $event)"
      [disabled]="type() === 'edit'"
    >
      <ng-template #content let-uploadedFiles>
        @if (uploadedFiles.length > 0) { {{ uploadedFiles.length }} {{ "common.files_selected" | translate }} }
      </ng-template>
    </p-fileUpload>
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="file2" class="font-semibold w-full">
      {{ "device_management.software.form.file_2" | translate }} *
    </label>
    <p-fileUpload
      id="file2"
      [showUploadButton]="false"
      [showCancelButton]="false"
      styleClass="customFileUpload"
      [style]="{ 'flex-direction': 'row' }"
      class="w-full"
      [chooseLabel]="translate.instant('device_management.software.form.choose_file')"
      [customUpload]="true"
      [auto]="false"
      (onSelect)="onFileSelect('file2', $event)"
      [disabled]="type() === 'edit'"
    >
      <ng-template #content let-uploadedFiles>
        @if (uploadedFiles.length > 0) { {{ uploadedFiles.length }} {{ "common.files_selected" | translate }} }
      </ng-template>
    </p-fileUpload>
  </div>
  <div class="flex flex-column gap-2 mb-3" style="grid-column: 1/3">
    <label for="remark"> {{ "device_management.software.form.remark" | translate }} </label>
    <textarea rows="5" cols="30" pInputTextarea formControlName="remark" [autoResize]="true" id="remark"></textarea>
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup" style="grid-column: 1/3">
    <app-button id="cancelBuildingButton" buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button
      buttonText="common.save"
      [disabled]="type() === 'edit' ? !form.valid :  !(form.valid && file1 && file2)"
      (click)="save()"
    ></app-button>
  </div>

  }
</div>
